<div class="card" id="deposits-and-downs">
    <div class="card-body">
        <h2 class="card-title">Deposits &amp; Down Payments</h2>
    </div>
    <ul class="list-group list-group-flush pay-list">
        @if ((!payments || (payments.length <= 0))) {
            <li class="list-group-item">No deposits or down payments at this time.</li>
        }
            
        @for (payment of payments; track payment) {
            <li class="list-group-item" (click)="selected($event, payment)">
                @if (!payment.url) {
                    <span class="material-icons">payments</span>
                }
                @if (payment.url) {
                    <img [src]="payment.url" />
                }
                <p class="due {{dueToClass(payment.due)}}">{{payment.due | date:'M/d'}}</p>
                <div class="text-truncate">
                    <p class="title">{{payment.contact}}</p>
                    <p class="subtitle">{{payment.stock}} {{payment.vehicle}}</p>
                </div>
                <div class="currency">
                    <p>{{payment.amount - (payment.paid || 0) | currency}}</p>
                    <p class="subtitle">{{payment.category | lowercase}}</p>
                </div>
            </li>
        }
    </ul>
</div>